export default __webpack_public_path__ + "static/media/alert-icon-3.6c3c3465.svg";